import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonCard, IonCardHeader, IonCardTitle, IonCardContent } from '@ionic/react';
import { IonSearchbar, IonBackButton, IonButtons, IonSpinner } from '@ionic/react';
import './pump_customers.css';
import axios from "axios";
import getApi from '../api';
import EnvironmentBadge from '../components/EnvironmentBadge';
import React, { useState, useEffect, useCallback } from 'react';

// Enklare och mer stabil useDebounce hook
function useDebounce(value: string, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}

interface PumpUser {
  id: number;
  name: string;
  company_name: string;
}

const PumpCustomers: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [results, setResults] = useState<PumpUser[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  
  // Använd vår egen debounce hook för sökningen
  const debouncedSearchQuery = useDebounce(searchQuery, 800);

  const api = getApi();

  // Hantera både initial data och sökningar
  useEffect(() => {
    setIsLoading(true);
    const controller = new AbortController();
    
    // Om söktermen är tom, hämta alla användare, annars sök
    const url = debouncedSearchQuery === ''
      ? "/user/allusers/?is_active=true&vattna=true"
      : `/user/allusers/?is_active=true&vattna=true&search=${encodeURIComponent(debouncedSearchQuery)}`;
    
    api.get(url, {
      signal: controller.signal
    })
      .then(res => {
        setResults(res.data.results);
        setIsLoading(false);
      })
      .catch(err => {
        if (axios.isCancel(err)) return;
        console.error(err);
        setIsLoading(false);
      });
    
    return () => controller.abort();
  }, [debouncedSearchQuery]);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  return (
    <IonPage placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonButtons slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonBackButton />
        </IonButtons>
          <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Kunder</IonTitle>
          <div slot="end" style={{paddingRight:'8px'}}><EnvironmentBadge /></div>
        </IonToolbar>
      </IonHeader>
      <IonContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonSearchbar
        placeholder="Sök Kund"
        value={searchQuery}
        onIonChange={e => handleSearch(e.detail.value || '')}
        debounce={800}
        animated={true}
        showCancelButton="focus"
        onPointerEnterCapture={undefined} 
        onPointerLeaveCapture={undefined}
      />
      
      {isLoading && (
        <div className="ion-text-center">
          <IonSpinner placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
        </div>
      )}

      <div>
        {results.map((result) => (
          <IonCard key={result.id} routerLink={"/PumpCustomer/" + result.id} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{result.name}</IonCardTitle>
            </IonCardHeader>
            <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <p>Företag: {result.company_name}</p>
            </IonCardContent>
          </IonCard>
        ))}
      </div>
      </IonContent>
    </IonPage>
  );
};

export default PumpCustomers;
